import React from 'react';
import styled from '@emotion/styled';

/**
 * ShareBar — one option and how much of the room chose it, for the wall:
 * a label, a bar for the share, the count. Three-way variants stack agree,
 * unsure and disagree in one bar. Bigger than the phone's SpreadBar; same idea.
 */
const Row = styled.div`display: grid; grid-template-columns: minmax(0, 1fr) 40% 3.5rem; gap: 1rem; align-items: center; font-size: ${(p) => p.$size}; color: #e8ecf2; line-height: 1.3;`;
const Bar = styled.div`display: flex; height: 1.4rem; border-radius: 6px; overflow: hidden; background: #1a1f2a;`;
const Seg = styled.div`flex: 0 0 ${(p) => p.$share * 100}%; background: ${(p) => p.$c}; transition: flex-basis 0.4s;`;
const N = styled.div`text-align: right; font-variant-numeric: tabular-nums; color: #98a2b3;`;
const Src = styled.span`display: block; font-size: 0.75em; color: #7b8794;`;

export const STANCE_COLORS = { agree: '#3fbf8f', unsure: '#c9cbd6', disagree: '#e05a5a', holds: '#3fbf8f', not_here: '#e05a5a' };

/**
 * @param {{ text: string, source?: string|null, total: number, parts: { key: string, count: number, color?: string }[], size?: string }} props
 */
export default function ShareBar({ text, source = null, total = 0, parts = [], size = '1.1rem' }) {
  const n = parts.reduce((s, p) => s + p.count, 0);
  return (
    <Row $size={size}>
      <div>{text}{source && <Src>{source}</Src>}</div>
      <Bar role="img" aria-label={text}>
        {parts.map((p) => (p.count > 0 && total > 0 ? <Seg key={p.key} $share={p.count / total} $c={p.color || STANCE_COLORS[p.key] || '#8ec1f0'} title={`${p.key}: ${p.count}`} /> : null))}
      </Bar>
      <N>{parts.length === 1 ? `${n} / ${total}` : n}</N>
    </Row>
  );
}
